import ManaParticle from "../../../ManaParticle"
import NodeCategories from "../../NodeCategories"
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"

export type ChaosDirectionNodeOptions = {} & SimpleManaNodeOptions

export default class ChaosDirectionNode extends SimpleManaNode {

	static nodeType = 'ChaosDirectionNode'
	static nodeName = "Chaos direction node"
	static nodeDesc = "Sets particle direction randomly"
	static nodeIcon = '✳'
	static category = NodeCategories.Direction

	onScroll(dir: number) { }

	async act(particle: ManaParticle) {
		if (particle.target) {
			particle.direction.rotateToDeg(Math.random() * 360)
		}

		return true
	}

}